// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"826c8910","332":"e9a06d34","593":"0e4a660b","625":"e395f49c","855":"b1c672bb"}[chunkId] + ".chunk.css";
};